import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService, StateService } from '@cosmos/angular/utils';
import { environment } from 'environments/environment';

@Component({
  selector: 'cosmos-impersonation-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonModule, TranslateModule],
  templateUrl: './impersonation-banner.component.html',
})
export class ImpersonationBannerComponent {
  private readonly authService = inject(AuthService);
  private readonly stateService = inject(StateService);

  protected readonly currentUser = toSignal(this.stateService.currentUser$, {
    initialValue: this.stateService.getCurrentUser(),
  });

  protected readonly isImpersonating = computed(() => !!this.currentUser()?.viewingAs);

  protected exitViewAs(): void {
    this.authService.exitViewAs().subscribe(() => {
      window.location.href = environment.ADMIN_URL;
    });
  }
}
